import AlpineIsland from '~/javascripts/components/AlpineIsland';
import BirthdayFields from '~/javascripts/components/LeadForm/BirthdayFields';
import ConsentInfoModal from '~/javascripts/components/DonateForm/ConsentInfoModal';
import InternationalPhoneNumberInput from '~/javascripts/components/InternationalPhoneNumberInput';
import RecaptchaText from '~/javascripts/components/RecaptchaText';
import StoreUtmParams from '~/javascripts/behaviors/StoreUtmParams';
import { observer, useLocalObservable } from 'mobx-react';
import { useEffect, useRef } from 'react';

const LeadForm = observer((props) => {
  const leadFormRef = useRef(null);

  const renderAdditionalInfoDropdown = () => {
    if (
      !props.additionalInfoDropdown ||
      props.additionalInfoDropdown.options.length < 2
    ) {
      return null;
    }

    const { label, placeholder, options } = props.additionalInfoDropdown;

    return (
      <div className='mailing-input-wrapper additional-dropdown max-w-xs mx-auto my-2'>
        <label className='calm-label' htmlFor='additional_info_dropdown'>
          {label}
        </label>
        <select
          className='w-full'
          id='additional_info_dropdown'
          name='additional_info_dropdown[option]'
        >
          <option value=''>{placeholder || 'Please select'}</option>
          {Array.isArray(options) &&
            options.map((option) => (
              <option key={`option-${option.value}`} value={option.value}>
                {option.value}
              </option>
            ))}
        </select>
        <input
          name='additional_info_dropdown[label]'
          type='hidden'
          value={label}
        />
      </div>
    );
  };

  const formattedOfferFromProps = () => {
    if (typeof props.offer === 'string') {
      return props.offer;
    } else if (typeof props.offer === 'object') {
      return props.offer?.value?.data?.name;
    }
  };

  const localStore = useLocalObservable(() => ({
    customWelcomeJourneyId: props.customWelcomeJourneyId || '',
    emailConsentGranted: props.countryFromLocale === 'us',
    offer: formattedOfferFromProps(),
    phoneNumberConsentGranted: false,
    get requirePhoneNumber() {
      return props.requirePhoneNumber || this.phoneNumberConsentGranted;
    },
    showPhoneNumber: props.showPhoneNumber && props.countryFromLocale === 'us',
    submitButtonText: props.submitButtonText || 'Subscribe',
  }));

  const isFooterForm = props.place === 'footer';

  useEffect(() => {
    if (leadFormRef.current) {
      StoreUtmParams($(leadFormRef.current));

      leadFormRef.current.addEventListener('htmx:afterRequest', (event) => {
        if (event.detail.xhr.status == 200 && props.useInlineThankYouBlock) {
          replaceLeadFormWithThankYouContent();
        }
      });
    }
  }, []);

  const replaceLeadFormWithThankYouContent = () => {
    if ($('.infosite-lead-form-thank-you-content').length > 0) {
      $('.infosite-lead-form-sign-up-content').addClass('hidden');
      $('.infosite-lead-form-thank-you-content').removeClass('hidden');
    } else {
      $('.lead-form-sign-up-content').addClass('hidden');
    }
  };

  const mailingListInputs = () => {
    const mailingListsToJoin = Array.isArray(props.mailingListsToJoin)
      ? props.mailingListsToJoin
      : Object.entries(props.mailingListsToJoin)
          .filter(([_k, v]) => v === true)
          .map(([k, _v]) => k);

    return mailingListsToJoin.map((mailingList) => (
      <input
        id={`user_${mailingList}`}
        key={mailingList}
        name={`mailing_list_subscriber[${mailingList}]`}
        type='hidden'
        value
      />
    ));
  };

  const handleBirthdayCheckboxChange = (checked) => {
    if (checked) {
      localStore.offer = props.birthdayPledgeCheckbox.offer?.value?.data?.name;
      localStore.customWelcomeJourneyId =
        props.birthdayPledgeCheckbox.customWelcomeJourneyId;
    } else {
      localStore.offer = formattedOfferFromProps();
      localStore.customWelcomeJourneyId = props.customWelcomeJourneyId || '';
    }
  };

  const onlyEmailConsentVisible = () => !localStore.showPhoneNumber;

  const emailConsentText = () => {
    if (onlyEmailConsentVisible()) {
      return (
        <div className='calm-email-consent-text'>
          <p>Email me with marketing updates about</p>
          <div className='flex space-x-1'>
            <p>charity: water&apos;s mission and initiatives</p>
            <a className='calm-question-mark' href='#more-consent-info'>
              ?
            </a>
          </div>
        </div>
      );
    } else {
      return 'Email';
    }
  };

  return (
    <>
      <div className='lead-form-wrapper theme-maji' style={{ lineHeight: '0' }}>
        <form
          {...{
            'hx-post': '/mailing_list_subscribers',
            'hx-target': '.lead-form-wrapper',
          }}
          className={`m-auto text-center w-full ${
            isFooterForm ? '' : 'max-w-xs mt-3'
          }`}
          data-parsley-validate
          data-store-utm-params-model='mailing_list_subscriber'
          data-with-credentials
          id='mailing-list-form'
          ref={leadFormRef}
        >
          <div className={`${isFooterForm ? 'md-flex' : ''}`}>
            <div
              className={`mailing-input-names md-flex md-justify-center max-w-xs mx-auto ${
                !isFooterForm && 'md-space-x-3'
              }`}
            >
              <div className='mailing-input-wrapper name first md-flex-1'>
                <label
                  className={`${
                    isFooterForm ? 'for-screen-readers-only' : 'calm-label'
                  }`}
                  htmlFor='name'
                >
                  First Name
                </label>
                <input
                  data-parsley-error-message='Please provide your first name'
                  id='user_name'
                  maxLength='255'
                  name='user[name]'
                  placeholder={isFooterForm ? 'First Name' : ''}
                  required
                  type='text'
                />
              </div>
              <div className='mailing-input-wrapper surname mt-2 md-mt-0 md-flex-1'>
                <label
                  className={`${
                    isFooterForm ? 'for-screen-readers-only' : 'calm-label'
                  }`}
                  htmlFor='surname'
                >
                  Last Name
                </label>
                <input
                  data-parsley-error-message='Please provide your last name'
                  id='user_surname'
                  maxLength='255'
                  name='user[surname]'
                  placeholder={isFooterForm ? 'Last Name' : ''}
                  required
                  type='text'
                />
              </div>
            </div>
            <div
              className={`mailing-input-wrapper email max-w-xs mt-2 mx-auto ${
                isFooterForm ? 'md-mt-0' : ''
              } ${props.showBirthday ? '' : 'second'}`}
            >
              <label
                className={`${
                  isFooterForm ? 'for-screen-readers-only' : 'calm-label'
                }`}
                htmlFor='email'
              >
                Email
              </label>
              <input
                data-parsley-email-tld=''
                data-parsley-error-message='Please provide a valid email address'
                id='user_email'
                maxLength='255'
                name='user[email]'
                placeholder={isFooterForm ? 'Email' : ''}
                required
                type='email'
              />
            </div>

            {isFooterForm && (
              <AlpineIsland componentName='RateLimitedRecaptchaForm'>
                <div
                  className='text-cw-red-text-small -text-left'
                  {...{ 'x-text': 'recaptchaError' }}
                />
                <button
                  type='submit'
                  {...{
                    'x-on:click.prevent': 'submit',
                    ':disabled': 'submitting',
                  }}
                  className={`button button--expand mailing-list-sign-up-button max-w-xs mx-auto ${
                    isFooterForm ? 'mt-2 md-mt-0' : ''
                  }`}
                >
                  <i
                    className='cw-icon-loop cw-icon-spin mr-1'
                    {...{ 'x-show': 'submitting' }}
                  />
                  {localStore.submitButtonText}
                </button>
              </AlpineIsland>
            )}
          </div>

          {props.showBirthday && (
            <BirthdayFields
              birthdayPledgeCheckbox={props.birthdayPledgeCheckbox}
              countryFromLocale={props.countryFromLocale}
              handleBirthdayCheckboxChange={handleBirthdayCheckboxChange}
              place={props.place}
              requireBirthday={props.requireBirthday}
            />
          )}

          {localStore.showPhoneNumber && (
            <>
              <div className='phone-number-fields max-w-xs mx-auto mt-2'>
                <label className='calm-label' htmlFor='user[phone_num]'>
                  Phone Number
                  {!localStore.requirePhoneNumber && ' (optional)'}
                </label>

                <InternationalPhoneNumberInput
                  defaultCountry='us'
                  hideOptionalPlaceholder={true}
                  inputName='user[phone_num]'
                  isRequired={localStore.requirePhoneNumber}
                  limitToUSOnly={true}
                />
              </div>
            </>
          )}

          {props.showConsentCheckboxes && (
            <div className='calm-checkboxes-wrapper mx-auto mt-2'>
              {!onlyEmailConsentVisible() && (
                <div className='w-full text-left space-x-2 flex calm-opt-in-text mb-1'>
                  <p>Choose how you want to hear from us</p>
                  <a className='calm-question-mark' href='#more-consent-info'>
                    ?
                  </a>
                </div>
              )}

              <div className='flex'>
                <div className='calm custom-check'>
                  <input
                    defaultChecked={localStore.emailConsentGranted}
                    id='email-consent-granted'
                    name='email_consent_granted'
                    onChange={() =>
                      (localStore.emailConsentGranted =
                        !localStore.emailConsentGranted)
                    }
                    type='checkbox'
                    value={localStore.emailConsentGranted}
                  />

                  <label htmlFor='email-consent-granted'>
                    {emailConsentText()}
                  </label>
                </div>

                {localStore.showPhoneNumber && (
                  <div className='calm custom-check ml-3'>
                    <input
                      defaultChecked={localStore.phoneNumberConsentGranted}
                      id='text-consent-granted'
                      name='text_consent_granted'
                      onChange={() =>
                        (localStore.phoneNumberConsentGranted =
                          !localStore.phoneNumberConsentGranted)
                      }
                      type='checkbox'
                      value={localStore.phoneNumberConsentGranted}
                    />
                    <label htmlFor='text-consent-granted'>Text message</label>
                  </div>
                )}
              </div>

              <input
                id='show-consent-checkboxes'
                name='show_consent_checkboxes'
                type='hidden'
                value={props.showConsentCheckboxes}
              />
            </div>
          )}

          {!isFooterForm && renderAdditionalInfoDropdown()}

          {!isFooterForm && (
            <AlpineIsland componentName='RateLimitedRecaptchaForm'>
              <div
                className='text-cw-red-text-small mb-1 -text-left'
                {...{ 'x-text': 'recaptchaError' }}
              />
              <button
                {...{
                  'x-on:click.prevent': 'submit',
                  ':disabled': 'submitting',
                }}
                className='button cw-button button--expand mailing-list-sign-up-button max-w-xs mx-auto mt-1'
                type='submit'
              >
                <i
                  className='cw-icon-loop cw-icon-spin mr-1'
                  {...{ 'x-show': 'submitting' }}
                />
                {localStore.submitButtonText}
              </button>
            </AlpineIsland>
          )}

          <input
            id='user_country'
            name='user[country]'
            type='hidden'
            value={props.countryFromLocale}
          />
          {mailingListInputs()}
          <input
            id='user_place'
            name='user[place]'
            type='hidden'
            value={props.place}
          />
          <input
            id='offer'
            name='offer'
            type='hidden'
            value={localStore.offer}
          />
          <input
            id='user_thank_you_flash_message'
            name='thank_you_flash_message'
            type='hidden'
            value={props.thankYouFlashMessage}
          />
          <input
            id='user_thank_you_page_path'
            name='thank_you_page_path'
            type='hidden'
            value={props.thankYouPagePath}
          />
          {props.useInlineThankYouBlock && (
            <>
              <input
                id='user_inline_thank_you_block'
                name='inline_thank_you_block'
                type='hidden'
                value={props.inlineThankYouBlockContent}
              />
              <input
                id='user_use_inline_thank_you_block'
                name='use_inline_thank_you_block'
                type='hidden'
                value={true}
              />
            </>
          )}
          <input
            id='user_send_default_welcome_emails'
            name='send_default_welcome_emails'
            type='hidden'
            value={
              props.sendDefaultWelcomeEmails === undefined
                ? 'true'
                : `${props.sendDefaultWelcomeEmails}`
            }
          />
          <input
            id='user_custom_welcome_journey_id'
            name='custom_welcome_journey_id'
            type='hidden'
            value={localStore.customWelcomeJourneyId}
          />
          <input
            id='user_offer_journey_id'
            name='offer_journey_id'
            type='hidden'
            value={props.offerJourneyId}
          />
        </form>

        <div className={`w-full ${isFooterForm ? '' : 'text-center'}`}>
          {props.countryFromLocale !== 'uk' && (
            <p
              className={`calm-disclaimer-text mx-auto my-1 text-left ${
                isFooterForm
                  ? 'normal-case mt-1 text-center'
                  : 'calm-checkboxes-wrapper '
              }`}
            >
              By clicking &ldquo;{localStore.submitButtonText}&rdquo;, you are
              submitting your information to charity:&nbsp;water.{' '}
              {localStore.showPhoneNumber && (
                <>
                  If you have opted to receive text messages, you agree to
                  receive messages such as promotions, offers, alerts, and
                  donation requests. Consent is not a condition of purchase.
                  Reply HELP to 71537 for help and STOP to cancel. Msg frequency
                  varies. Msg & data rates may apply. View{' '}
                  <a
                    className='font-normal underline'
                    href='https://www.charitywater.org/sms-terms-of-service'
                  >
                    Terms
                  </a>
                  {' & '}
                  <a
                    className='font-normal underline'
                    href='https://www.charitywater.org/privacy-policy/sms'
                  >
                    Privacy
                  </a>
                  .
                </>
              )}
            </p>
          )}

          {props.countryFromLocale === 'uk' && (
            <p
              className={`h80 italic normal-case text-grey-60 pt-1 balance-text ${
                isFooterForm ? '' : 'max-w-xs mx-auto'
              }`}
            >
              By clicking &ldquo;{localStore.submitButtonText}&rdquo; I accept
              the terms and conditions of the privacy policy and consent to
              receive email updates and stories from charity:&nbsp;water.
            </p>
          )}
          <RecaptchaText classes='text-grey-50 mt-1' />
        </div>

        <ConsentInfoModal
          includeMail={false}
          includeSms={localStore.showPhoneNumber}
          modalId='more-consent-info'
        />
      </div>
    </>
  );
});

export default LeadForm;
